import useFreePlanStatus from '../../hooks/useFreePlanStatus';
import './FreePlanBanner.css';

/**
 * Banner de aviso sobre expiração do plano FREE
 * Exibe diferentes níveis de urgência baseado nos dias restantes
 */
export default function FreePlanBanner() {
  const freeStatus = useFreePlanStatus();
  
  // Não exibe se não deve mostrar aviso
  if (!freeStatus.shouldShowWarning) {
    return null;
  }
  
  // Determinar classes CSS baseadas no nível de urgência
  const variantClass = freeStatus.urgencyLevel === 'danger' 
    ? 'free-plan-banner-danger' 
    : freeStatus.urgencyLevel === 'warning' 
    ? 'free-plan-banner-warning' 
    : 'free-plan-banner-info';
  
  // Formatar data de expiração
  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    return new Date(isoDate).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  
  // Ícone baseado no nível de urgência
  const getIcon = () => {
    if (freeStatus.urgencyLevel === 'danger') {
      return (
        <svg className="free-plan-banner-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      );
    }
    if (freeStatus.urgencyLevel === 'warning') {
      return (
        <svg className="free-plan-banner-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    }
    return (
      <svg className="free-plan-banner-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    );
  };
  
  // Título baseado no nível de urgência
  const getTitle = () => {
    if (freeStatus.urgencyLevel === 'danger') {
      return freeStatus.daysRemaining === 1 
        ? '🔴 Último dia de acesso gratuito!' 
        : '🔴 Seu acesso gratuito expira hoje!';
    }
    if (freeStatus.urgencyLevel === 'warning') {
      return '⚠️ Atenção: seu período gratuito está acabando';
    }
    return '📅 Seu período gratuito está acabando';
  };
  
  return (
    <div className={`free-plan-banner ${variantClass}`}>
      <div className="free-plan-banner-content">
        <div className="free-plan-banner-header">
          {getIcon()}
          <h3 className="free-plan-banner-title">{getTitle()}</h3>
        </div>
        <div className="free-plan-banner-description">
          <p>
            {freeStatus.message}.{" "}
            {freeStatus.expirationDate && (
              <span>
                Seu acesso expira em{" "}
                <strong>{formatDate(freeStatus.expirationDate)}</strong>.
              </span>
            )}
          </p>
          <p className="free-plan-banner-cta">
            <a href="/planos" className="free-plan-banner-link">
              Ver planos disponíveis →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
